module.exports = __webpack_public_path__ + "static/media/master.d78dea74.svg";